import React, { useEffect, useState } from 'react'
import { client } from '@Utils'
import { Pagination } from 'react-bootstrap'
import { GradeLogViewer } from './GradeLogViewer'

export const GradeLogListView = ({ queryParams }) => {
  console.log('QUERY PARAMS :: ', queryParams)
  const queryString = new URLSearchParams(queryParams).toString()
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [gradeLogs, setGradeLogs] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchGradeLogs = async () => {
      setIsLoading(true)
      try {
        const resp = await client.get(
          `/account/admin_lti13.getGradeLogs/-/${currentPage}/?${queryString}`
        )
        setGradeLogs(resp.data.gradeLogs)
        setTotalPages(resp.data.totalPages)
        setPageSize(resp.data.pageSize)
      } catch (err) {
        console.error(err)
        //TODO: Use better error reporting to the UI
        alert(err.response.data.error)
      } finally {
        setIsLoading(false)
      }
    }
    fetchGradeLogs()
  }, [currentPage])

  const pagination =
    totalPages > 1 ? (
      <Pagination
        prev="« Prev"
        next="Next »"
        ellipsis
        boundaryLinks
        items={totalPages}
        maxButtons={10}
        activePage={currentPage}
        onSelect={setCurrentPage}
      />
    ) : (
      <span />
    )

  return (
    <div className="card-myed">
      <h3>Failed Grade Push Attempts:</h3>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <div id="grade-log-container">
          {gradeLogs.map((gradeLog, i) => (
            <div key={i}>
              <GradeLogViewer
                key={i}
                index={i + 1 + (currentPage - 1) * pageSize}
                gradeLog={gradeLog}
              />
            </div>
          ))}
          <div>TOTAL PAGES :: {totalPages}</div>
          <div>CURRENT PAGE :: {currentPage}</div>
          <div>
            <a
              onClick={() => {
                setCurrentPage(Math.max(1, currentPage - 1))
              }}
            >
              Prev
            </a>
            <a
              onClick={() => {
                setCurrentPage(Math.min(currentPage + 1, totalPages))
              }}
            >
              Next
            </a>
            {pagination}
          </div>
        </div>
      )}
    </div>
  )
}
